import { type Treaty, treaty } from '@elysiajs/eden'
import type { Api } from '@k2/api'
import { createFetch, type FetchClient } from 'fetch-braid'
import { type App, type InjectionKey, inject } from 'vue'
import { useOAuthFetch } from 'vue-oidc'

export * from './ndjson'
export * from './request'
export * from './stream'

export type ApiClient = Treaty.Create<Api>

const API: InjectionKey<ApiClient> = Symbol('api')
const FETCH: InjectionKey<FetchClient> = Symbol('fetch')

export const createApi = () => ({
  install: (app: App) => {
    // Inside `runWithContext` because `useOAuthFetch` resolves through `inject`; provided rather than stored because Pinia would proxy the Eden client.
    app.runWithContext(() => {
      // `client.fetch` is stable and composes per call, so treaty takes it now and still sees a strand braided in later.
      const client = createFetch(useOAuthFetch() as typeof fetch)
      app.provide(FETCH, client)
      // parseDate off: Eden would turn a date-looking string, such as the card option "2026-10-05", into a Date.
      app.provide(API, treaty<Api>(process.env.API_URL ?? 'localhost:3002', { fetcher: client.fetch, parseDate: false }))
    })
  }
})

export const useApi = () => inject(API) as ApiClient

export const useApiFetch = () => inject(FETCH) as FetchClient
